import { cn } from '@/utilities/ui'
import { ClassValue } from 'clsx'
import { Category } from '@/payload-types'
import { PropsWithChildren } from 'react'

import { SidebarAds } from '../SidebarAds'
import { Breadcrumbs } from '../Breadcrumbs'
import { NewsletterSignup } from '../NewsletterSignup'
import { AffiliateDisclaimer } from '../AffiliateDisclaimer'

export interface Props {
    heading?: {
        title: string
        tagline: string
    }
    hasRightRail?: boolean
    classes?: {
        container?: ClassValue
        main?: ClassValue
        rail?: ClassValue
    }
    breadcrumbs?: Category['breadcrumbs']
    showNewsletterSignup?: boolean
    affiliateDisclaimerLink?: string
}

export function OneColList({ children, heading, hasRightRail, classes, breadcrumbs, showNewsletterSignup, affiliateDisclaimerLink }: PropsWithChildren<Props>) {
    return (
        <div className={cn('flex flex-col justify-center max-w-[1336px] container', classes?.container)}>
            {breadcrumbs && <Breadcrumbs crumbs={breadcrumbs} />}
            {heading && (
                <div className='flex flex-col justify-center items-center py-4 mb-6'>
                    <h1 className='text-accent text-4xl md:text-5xl font-bold pb-2'>{heading.title}</h1>
                    <h2 className='text-lg md:text-xl'>{heading.tagline}</h2>
                </div>
            )}
            {affiliateDisclaimerLink && <AffiliateDisclaimer url={affiliateDisclaimerLink} />}
            {showNewsletterSignup && <NewsletterSignup className='max-w-[900px] mx-auto pb-4' />}
            <div className={cn({ 'grid grid-cols-1': true, 'lg:grid-cols-3': hasRightRail })}>
                <main
                    className={cn(
                        'col-span-3 grid grid-cols-1 divide-y divide-slate-300 *:py-4',
                        {
                            'lg:col-span-2 lg:border-r border-slate-300': hasRightRail,
                        },
                        classes?.main,
                    )}
                >
                    {children}
                </main>
                <aside className={cn('hidden', { 'lg:block': hasRightRail }, classes?.rail)}>
                    <SidebarAds adCount={7} adWidth={336} adHeight={600} />
                </aside>
            </div>
        </div>
    )
}
